<div *ngIf="row.section" class="grid__col-12 guts-p-b-3-half">
  <!-- Header (for everything but carousels, which have their own header) -->
  <dgx-flex-row-header
    *ngIf="!useCarousels || row.section.layoutConfig.displayType !== 'Single'"
    [hideLinks]="hideLinks"
    [links]="links"
    [markdownDescription]="row.section.description"
    [menuConfig]="menuConfig"
    [permanentEditMode]="permanentEditMode"
    [row]="row"
    [useCarousels]="useCarousels"
    (editRow)="onEditRow($event)"
    (toggleReorderRow)="onToggleReorder()"
  ></dgx-flex-row-header>

  <!-- Body -->
  <!-- 1 row carousel -->
  <ng-container
    *ngIf="useCarousels && row.section.layoutConfig.displayType === 'Single'"
  >
    <dgx-carousel-content
      [permanentEditMode]="permanentEditMode"
      [customSlidesPerView]="customSlidesPerView"
      [row]="row"
      [loadingSuggestions]="loadingSuggestions"
      [label]="row.section.name || row.displayType"
      [menuConfig]="menuConfig"
      [links]="links"
      [markdownDescription]="row.section.description"
      (addResource)="addResource()"
      (removeSuggestion)="onRemoveSuggestion($event)"
      data-dgprop-render-method="Plan Carousel"
    ></dgx-carousel-content>
  </ng-container>

  <!-- Double row height or all items -->
  <ng-container
    *ngIf="
      (!useCarousels && row.section.layoutConfig.displayType !== 'None') ||
      row.section.layoutConfig.displayType === 'All' ||
      row.section.layoutConfig.displayType === 'Double'
    "
  >
    <dgx-flex-grid
      [row]="row"
      [isReordering]="isReordering"
      [disablePlanImage]="disablePlanImage"
      (removeSuggestion)="onRemoveSuggestion($event)"
      (addResource)="addResource()"
      (rowReordered)="onEditRow($event)"
      data-dgprop-render-method="Plan Grid"
    >
    </dgx-flex-grid>
  </ng-container>

  <!-- Action Item row -->
  <ng-container *ngIf="row.section.resourceType === 'LinkText'">
    <dgx-link-text-row [row]="row"></dgx-link-text-row>
  </ng-container>

  <!-- Freeform text row -->
  <ng-container *ngIf="row.section.resourceType === 'FreeformText'">
    <dgx-free-text-row [row]="row"></dgx-free-text-row>
  </ng-container>

  <!-- Show all button -->
  <button
    *ngIf="!useCarousels && row.canViewAll && !isReordering"
    (click)="onShowUpdate(!row.isViewAll)"
    df-button
    df-button-square
    dfButtonType="primary"
    class="flex-row__button guts-m-h-auto guts-m-t-2 bg-color-ebony-a08 color-ebony"
    data-dgat="flex-row-93b"
  >
    <ng-container *ngIf="!row.isViewAll; else showLess">
      <df-icon icon="chevron-down"></df-icon>
      {{ 'Core_ShowAll' | translate }}
    </ng-container>
    <ng-template #showLess>
      <df-icon icon="chevron-up"></df-icon>
      {{ 'Core_ShowLess' | translate }}
    </ng-template>
  </button>
</div>
